var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('data-table',{attrs:{"numerador":"","headers":_vm.cabeceras,"data":_vm.data,"acciones":_vm.acciones,"max":10,"idtabla":"historialAcciones"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }